export const getIsMobile = state => state.userDevice.isMobile

export const getIsMobileOrTablet = state => state.userDevice.isMobile || state.userDevice.isTablet

export const getIsTabletInPortrait = state => state.userDevice.isTabletInPortrait



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/userDevice/userDevice.selectors.js